import apiClient from "./apiClient"

export interface StateItem {
  _id: number
  state: string
}

export interface StatesResponse {
  success: boolean
  count?: number
  data: StateItem[]
}

export type SelectOption = { value: string; label: string }

/** Fetch states from API - returns react-select options */
export const getStatesOptions = async (): Promise<SelectOption[]> => {
  const res = await apiClient.get<StatesResponse>("/api/dropdowns/getStates")
  const raw = res?.data?.data ?? res?.data
  const arr = Array.isArray(raw) ? raw : []
  return arr.map((item: StateItem) => ({
    value: item.state,
    label: item.state,
  }))
}

export interface BrokerItem {
  _id: string
  fullName: string
  email?: string
  role?: string
  mobileNumber?: string
  state?: string
  city?: string
}

export interface BrokerListResponse {
  success: boolean
  count?: number
  data: BrokerItem[]
}

/** Fetch broker list from API (JWT required). Returns react-select options with value = _id, label = fullName. */
export const getBrokerListOptions = async (): Promise<SelectOption[]> => {
  const res = await apiClient.get<BrokerListResponse>("/api/dropdowns/getBrokerList")
  const raw = res?.data?.data ?? res?.data
  const arr = Array.isArray(raw) ? raw : []
  return arr.map((item: BrokerItem) => ({
    value: item._id,
    label: item.fullName ? `${item.fullName}${item.email ? ` (${item.email})` : ""}` : item._id,
  }))
}
